import styles from './Login.module.scss';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import LoginHeader from './Header/Header';
import LoginInfo from './Title/Title';
import LoginForm from './Form/Form';
import LoginSlogan from './Slogan/Slogan';
import Error from './Error/Error';

function Login({ history }) {
    const { isAuth } = useSelector(state => state.auth);

    useEffect(() => {
        if (isAuth) {
            history.push('/app');
        }
    }, [isAuth]);

    return (
        <div className={styles.login}>
            <div className={classNames(styles.section, styles.left)}>
                <LoginHeader />
                <div className={styles.content}>
                    <LoginInfo />
                    <LoginForm />
                    <Error />
                </div>
            </div>
            <div className={classNames(styles.section, styles.right)}>
                <div className={classNames(styles.content, styles.slogan)}>
                    <LoginSlogan />
                </div>
            </div>
        </div>
    );
}

export default Login;
